// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_update-form__bS6EB .Form_mapped-profile__H39C1 {
  margin-top: 3px;
  display: flex;
  padding: 10px 15px;
  justify-content: space-between;
  background: white;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
.Form_update-form__bS6EB .Form_mapped-profile__H39C1 .Form_profile-summary__aTS\\+Q {
  display: flex;
}
.Form_update-form__bS6EB .Form_mapped-profile__H39C1 .Form_profile-summary__aTS\\+Q .Form_profile-img__PHnlb img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.Form_update-form__bS6EB .Form_mapped-profile__H39C1 .Form_profile-summary__aTS\\+Q .Form_profile-info__uh160 {
  margin-left: 10px;
  color: #6f6f6f;
}
.Form_update-form__bS6EB .Form_mapped-profile__H39C1 .Form_profile-summary__aTS\\+Q .Form_profile-info__uh160 .Form_profile-name__RpSfT {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px !important;
}
.Form_update-form__bS6EB .Form_mapped-profile__H39C1 .Form_delete-mapped-profile__5xib6 {
  cursor: pointer;
}
.Form_update-form__bS6EB .Form_update-button__pgLva {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountCreate/Components/Form/Form.module.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AACI;EACE,aAAA;AACN;AACQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACV;AAEM;EACE,iBAAA;EACA,cAAA;AAAR;AACQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AACV;AAGI;EACE,eAAA;AADN;AAIE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AAFJ","sourcesContent":[".update-form {\n  .mapped-profile {\n    margin-top: 3px;\n    display: flex;\n    padding: 10px 15px;\n    justify-content: space-between;\n    background: white;\n    border-radius: 5px;\n    border: 1px solid #d9d9d9;\n    .profile-summary {\n      display: flex;\n      .profile-img {\n        img {\n          width: 80px;\n          height: 80px;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n      .profile-info {\n        margin-left: 10px;\n        color: #6f6f6f;\n        .profile-name {\n          color: black;\n          font-weight: 600;\n          font-size: 16px;\n          margin-bottom: 10px !important;\n        }\n      }\n    }\n    .delete-mapped-profile {\n      cursor: pointer;\n    }\n  }\n  .update-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"update-form": `Form_update-form__bS6EB`,
	"mapped-profile": `Form_mapped-profile__H39C1`,
	"profile-summary": `Form_profile-summary__aTS+Q`,
	"profile-img": `Form_profile-img__PHnlb`,
	"profile-info": `Form_profile-info__uh160`,
	"profile-name": `Form_profile-name__RpSfT`,
	"delete-mapped-profile": `Form_delete-mapped-profile__5xib6`,
	"update-button": `Form_update-button__pgLva`
};
export default ___CSS_LOADER_EXPORT___;
